import { useTrivia } from '../../../../hooks';
import { ModalTriviaActions, QuestionTrivia, ResultTrivia, StartTrivia, TriviaPagination } from './';

export const ModalTrivia = () => {
    const { isLoadTrivia, activeQuestion, getTrivia, result, isOpenTrivia, onCloseModalTrivia, triviaId } = useTrivia();

    /**
     * Permite ejecutar la trivia
     */
    const startTrivia = () => {
        getTrivia();
    }

    /**
     * Permite cerrar la trivia
     */
    const closeTrivia = () => {
        const overlay = document.querySelector('.js-backdrop');
        overlay?.classList.remove("visible-fadein");
        onCloseModalTrivia();
    }

    return (
        <div className={`modal ${isOpenTrivia ? 'visible-slideup' : ''}`} data-modal-win="trivia">
            <div className="modal__header">
                <h2 className="modal__title">Trivia: {isLoadTrivia}</h2>
                <button className="btn btn-rounded btn-rounded-transparent btn-close" aria-label="Cerrar ventana de Trivia" onClick={closeTrivia}>
                    <span className="btn__icon"><i className="icon icon-vpro-close"></i></span>
                </button>
            </div>
            <div className="modal__body main-sb">
                {
                    (isLoadTrivia || !activeQuestion) && (<StartTrivia startTrivia={startTrivia} />)
                }
                {
                    (activeQuestion && !result && triviaId) && (<QuestionTrivia question={activeQuestion} triviaId={triviaId} />)
                }
                {
                    (activeQuestion && !result) && (<TriviaPagination />)
                }
                {
                    result && (<ResultTrivia />)
                }
            </div>
            <ModalTriviaActions />
        </div>
    )
}
